export const styles = {
  placesWrapper: {
    position: 'relative',
  },

  placesAutocomplete: {
    width: '100%',
  },

  placesInput: {
    width: `100%`,
    height: '35px',
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    padding: '6px 12px',
    fontSize: '1rem',
    outline: `none`,
    textOverflow: `ellipses`,
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: '1.1876em',
    letterSpacing: '0.00938em',

    '&:hover': {
      borderColor: 'rgba(0, 0, 0, 0.87)',
    },
  },

  placesRemoveBtn: {
    position: 'absolute',
    top: '50%',
    right: '34%',
    transform: 'translateY(-50%)',
    borderRadius: '50%',
    padding: '2px',
    minWidth: '24px',

    '&:hover': {
      cursor: 'pointer',
    },
  },

  icon: {
    color: '#004360',
    marginRight: '16px',
  },

  textFieldV2: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    flexDirection: 'row',
    boxSizing: 'border-box',
    border: '1px solid #E2E2FC',
    borderRadius: '8px',
    '& fieldset': {
      border: '0px',
    },
    '& .MuiOutlinedInput-root': {
      display: 'flex',
      alignItems: 'baseline',
      padding: '2px !important',
    },
    '& .MuiAutocomplete-endAdornment': {
      display: 'none',
    },
  },

  customInput: {
    '& .MuiInputBase-root': {
      background: '#f8f8f8',
      borderRadius: 4,
      height: 52,
      padding: 0,
      color: '#222',
      fontSize: '16px',
      border: 'none',
      boxShadow: 'none',
      alignItems: 'center',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none !important',
        padding: 0,
      },
      '&:hover fieldset': {
        border: 'none !important',
        padding: 0,
      },
      '&.Mui-focused fieldset': {
        border: 'none !important',
        padding: 0,
      },
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
      padding: 0,
    },
    '& input, & .MuiInputBase-input, & .MuiOutlinedInput-input, & .MuiAutocomplete-input, & .MuiAutocomplete-inputFocused, & .MuiInputBase-inputAdornedEnd, & .MuiOutlinedInput-inputAdornedEnd, & .MuiInputBase-inputMarginDense, & .MuiOutlinedInput-inputMarginDense': {
      padding: 0,
      marginLeft: 14,
      height: 52,
      boxSizing: 'border-box',
      fontSize: '16px',
      color: '#222',
      background: 'transparent',
      lineHeight: '52px',
      fontFamily: "'Roboto', sans-serif",
      fontWeight: 300,
      letterSpacing: '0.6px',
    },
    '& input::placeholder': {
      fontSize: '14px',
      color: '#aaa',
      letterSpacing: '0.6px',
      opacity: 1,
      fontFamily: "'Proxima Nova', sans-serif",
      fontWeight: 300,
    },
  },
}

export default styles
